import useUpdateShopifyPreferenceNotifications from "@babackapp/private-api-client/client/use-update-shopify-preference-notifications";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useTranslation } from "react-i18next";
import { useTemplatesEditorConfig } from "../context/templates-editor-config-context";
import useCurrentShopSuspense from "../hooks/use-current-shop-suspense";
import { mergeEmailsTheme } from "../lib/merge-emails-theme";
import { EmailsThemeForm } from "./emails-theme-form";

/** Edits the return emails theme, `preferences.notifications.emailsTheme`. */
export function ReturnEmailsThemeDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation("trackoffice");
  const { data: shop } = useCurrentShopSuspense();
  const { theme } = useTemplatesEditorConfig();
  const { mutateAsync: updateNotifications } =
    useUpdateShopifyPreferenceNotifications(shop);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>
            {t("templatesEditor.returnTheme.title", "Return emails theme")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "templatesEditor.returnTheme.description",
              "Applies to all your return emails.",
            )}
          </DialogDescription>
        </DialogHeader>
        <EmailsThemeForm
          theme={theme}
          onSubmit={async (newTheme) => {
            await updateNotifications({
              emailsTheme: mergeEmailsTheme(newTheme, theme),
            });
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
